import { MediaDevice } from 'core/models/mediaDevice';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';

export class MediaDeviceStatusError extends Error {
}

export class MediaDevicePostCommandError extends MediaDeviceStatusError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(reason: any) {
        super(`cannot post a command because: ${reason}`);
    }
}

export class MediaDeviceStatusConnectionError extends MediaDeviceStatusError {
    constructor(MediaDeviceId: MediaDevice.Id) {
        super(`cannot connect to the server to sense the status of MediaDevice ${MediaDeviceId}`);
    }
}

export type MediaDeviceStatusListener = (status: MediaDevice.Status) => void;
export type MediaDeviceStatusErrorListener = (error: MediaDeviceStatusError) => void;

export interface MediaDeviceRepository {
    addStatusListener(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, listener: MediaDeviceStatusListener): void;
    removeStatusListener(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, listener: MediaDeviceStatusListener): void;

    addMediaDeviceStatusErrorListener(listener: MediaDeviceStatusErrorListener): void;
    removeMediaDeviceStatusErrorListener(listener: MediaDeviceStatusErrorListener): void;

    startPublish(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id): Promise<void>;
    stopPublish(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id): Promise<void>;
    restartPublish(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id): Promise<void>;

    getVideoParams(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id): Promise<Partial<MediaDevice.VideoConfig>>;
    setVideoParams(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id, videoParams: Partial<MediaDevice.VideoConfig>): Promise<void>;

    getAudioParams(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id): Promise<Partial<MediaDevice.AudioConfig>>;
    setAudioParams(mediaDeviceId: MediaDevice.Id, projectId: Project.Id, environmentId: Environment.Id, audioParams: Partial<MediaDevice.AudioConfig>): Promise<void>;
}
